"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
    mutation patchProfileService($patch: ProfilePatch!, $profileId: Int!) {
        updateProfile(input: { patch: $patch, profileId: $profileId }) {
            profile {
                profileId
                budgetConfidence
                buyerSituation
                cashBudget
                fundingSource
                hasLand
                isPreApproved
                landType
                landZip
                lotNumber
                preApprovalAmount
                preferredBeds
                preferredBaths
                profileType
                propertyDescription
                targetMoveDateMonth
                targetMoveDateYear
                topFavoriteHome
                likedFeatures {
                    nodes {
                        feature {
                            name
                            type
                            url
                            featureId
                        }
                    }
                }
            }
        }
    }
`;exports.patchProfile=e;
//# sourceMappingURL=queries.js.map
